import React from "react";
import { Flex, Grid, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickLandingSection from "@/features/pathpick/features/landing/components/PathPickLandingSection";
import {
  PATHPICK_LANDING_COLORS,
  SOLUTION_ITEM_KEYS,
} from "@/features/pathpick/features/landing/constants";

// 패스픽이 소싱 과정을 어떻게 나눠 푸는지 — 상품 찾기 → 선정 → 일괄 등록 → API 자동화
function PathPickLandingSolutionSection() {
  const { t } = useI18nHelper();

  return (
    <PathPickLandingSection title={t("path_pick_landing:solution.title")}>
      <Grid
        templateColumns={{
          base: "1fr",
          md: "repeat(2, 1fr)",
          lg: "repeat(4, 1fr)",
        }}
        gap={{ base: "24px", lg: "0px" }}
      >
        {SOLUTION_ITEM_KEYS.map((key, index) => (
          <Flex
            key={key}
            flexDirection={"column"}
            gap={"10px"}
            paddingX={{ base: "0px", lg: "20px" }}
            // 시안: 항목 사이를 세로선으로 나눈다. 첫 칸은 왼쪽 선을 두지 않는다.
            borderLeft={{
              base: "none",
              lg:
                index === 0
                  ? "none"
                  : `1px solid ${PATHPICK_LANDING_COLORS.border}`,
            }}
          >
            <Flex gap={"8px"} alignItems={"center"}>
              <Text
                textStyle={"body-sm-bold"}
                color={PATHPICK_LANDING_COLORS.textFaint}
              >
                {String(index + 1).padStart(2, "0")}
              </Text>
              <Text
                textStyle={"body-sm-bold"}
                color={PATHPICK_LANDING_COLORS.green}
              >
                {t(`path_pick_landing:solution.items.${key}.badge`)}
              </Text>
            </Flex>
            <Text
              textStyle={"body-md-bold"}
              fontSize={"16px"}
              color={PATHPICK_LANDING_COLORS.textStrong}
            >
              {t(`path_pick_landing:solution.items.${key}.title`)}
            </Text>
            <Text
              textStyle={"body-sm-regular"}
              color={PATHPICK_LANDING_COLORS.textMuted}
            >
              {t(`path_pick_landing:solution.items.${key}.description`)}
            </Text>
          </Flex>
        ))}
      </Grid>
    </PathPickLandingSection>
  );
}

export default PathPickLandingSolutionSection;
